module.exports = __webpack_public_path__ + "img/467.d6dbd886.png";